import {User} from "../api/accessControl/User.ts";
import {Client} from "../pages/app/partner/Client.ts";
import {usePartnerClients} from "./usePartnerClients.ts";
import {PartnerClientSelection, usePartnerClientSelection} from "./usePartnerClientSelection.ts";

export interface PartnerClientScope extends PartnerClientSelection {
    clients: Client[];
    selectedClient: Client | null;
}

export function usePartnerClientScope(currentUser: User): PartnerClientScope {
    const clients = usePartnerClients(currentUser);
    const selection = usePartnerClientSelection(currentUser.id);
    const selectedClient = clients.find((client) => client.id === selection.selectedClientId) ?? null;

    return {...selection, clients, selectedClient};
}
